import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable()
export class NotificationBadgeService {
  private count = new BehaviorSubject('0')
  currentCount = this.count.asObservable()

  constructor() {}

  updateCount(e: string) {
    this.count.next(e)
  }
}
